// api/overview.js
import { apiGet, apiPost} from './http';

// GET /admin/overview/home
export function fetchHomeRuntime(config = {}) {
  return apiGet('/overview/runtime', {}, config); // 可传 { silent:true } 控制提示
}

// POST /admin/overview/bind-invite  绑定邀请关系
export function bindInviteAddress(inviteAddress, config = {}) {
  return apiPost(
    '/overview/bind-invite',
    { inviteAddress },
    {
      successMsg: 'Successful',
      ...config,
    }
  );
}

// ===== APP 首页 =====
export function fetchAppHome(config = {}) {
  return apiGet(
    '/app/home/home',
    {},
    {
      silent: true,
      ...config
    }
  );
}


// ===== APP 个人中心 =====

// 获取个人中心数据
export function fetchAppMe(config = {}) {
  return apiGet(
    '/app/home/index',
    {},
    {
      silent: true,
      ...config
    }
  );
}

// 修改 ENI 地址
export function updateEniAddress(eniAddress, config = {}) {
  return apiPost(
    '/app/home/eni-address',
    { eniAddress },
    {
      successMsg: 'ENI address saved',
      ...config
    }
  );
}




